const map = {
	"./code-command.jpg": 648,
	"./dark.jpg": 835,
	"./forge-project.jpg": 230,
	"./gallery.jpg": 197,
	"./git-it-done.jpg": 928,
	"./homepage.jpg": 539,
	"./horiseon.jpg": 864,
	"./hub.jpg": 262,
	"./just-tech-news.jpg": 54,
	"./led.jpg": 292,
	"./nft-marketplace.jpg": 129,
	"./note-taker.jpg": 317,
	"./password-generator.jpg": 8,
	"./pexels-neo.jpg": 141,
	"./profile.jpg": 724,
	"./run-buddy.jpg": 607,
	"./taskinator.jpg": 537,
	"./taskmaster-pro.jpg": 624,
	"./tech-blog.jpg": 782,
	"./weather-dashboard.jpg": 348,
	"./work-day-scheduler.jpg": 961,
	"./zoo-keepr.jpg": 695
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316;